var ee = Object.defineProperty;
var te = (t, e, o) => e in t ? ee(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o;
var h = (t, e, o) => (te(t, typeof e != "symbol" ? e + "" : e, o), o);
import { findChildren as D, Node as x, mergeAttributes as w, InputRule as q, isTextSelection as oe, isNodeSelection as ne, posToDOMRect as j, Extension as C, findParentNode as re, getMarkRange as V, combineTransactionSteps as ie, getChangedRanges as se, findChildrenInRange as ae, Mark as K, extensions as A, Editor as de } from "@tiptap/core";
import le from "@tiptap/extension-bold";
import ce from "@tiptap/extension-code";
import ue from "@tiptap/extension-dropcursor";
import he from "@tiptap/extension-gapcursor";
import pe from "@tiptap/extension-hard-break";
import { History as me } from "@tiptap/extension-history";
import fe from "@tiptap/extension-italic";
import ke from "@tiptap/extension-strike";
import ge from "@tiptap/extension-text";
import be from "@tiptap/extension-underline";
import { Slice as E, Fragment as H } from "prosemirror-model";
import { PluginKey as v, Plugin as B, TextSelection as F, Selection as _, NodeSelection as ye } from "prosemirror-state";
import * as ve from "prosemirror-view";
import { Decoration as N, DecorationSet as L } from "prosemirror-view";
import { Link as J } from "@tiptap/extension-link";
import { v4 as Ce } from "uuid";
function f(t, e) {
  if (e <= 0 || e > t.nodeSize)
    return;
  const o = t.resolve(e), n = o.depth;
  let r = o.node(n), a = n;
  for (; a >= 0; ) {
    if (a === 0)
      return;
    if (r.type.name === "blockContainer")
      break;
    a -= 1, r = o.node(a);
  }
  const d = r.attrs.id, s = r.firstChild, i = s.type, l = r.childCount === 2 ? r.lastChild.childCount : 0, u = o.start(a), c = o.end(a);
  return {
    id: d,
    node: r,
    contentNode: s,
    contentType: i,
    numChildBlocks: l,
    startPos: u,
    endPos: c,
    depth: a
  };
}
const W = new v("previous-blocks"), Be = {
  index: "index",
  level: "level",
  type: "type",
  depth: "depth",
  "depth-change": "depth-change"
}, Me = () => new B({
  key: W,
  view(t) {
    return {
      update: async (e, o) => {
        var n;
        ((n = this.key) == null ? void 0 : n.getState(e.state).updatedBlocks.size) > 0 && setTimeout(() => {
          e.dispatch(
            e.state.tr.setMeta(W, { clearUpdate: !0 })
          );
        }, 0);
      }
    };
  },
  state: {
    init() {
      return {
        prevTransactionOldBlockAttrs: {},
        currentTransactionOldBlockAttrs: {},
        updatedBlocks: /* @__PURE__ */ new Set()
      };
    },
    apply(t, e, o, n) {
      if (e.currentTransactionOldBlockAttrs = {}, e.updatedBlocks.clear(), !t.docChanged || o.doc.eq(n.doc))
        return e;
      const r = {}, a = D(o.doc, (i) => i.attrs.id), d = new Map(
        a.map((i) => [i.node.attrs.id, i])
      ), s = D(n.doc, (i) => i.attrs.id);
      for (let i of s) {
        const l = d.get(i.node.attrs.id), u = l == null ? void 0 : l.node.firstChild, c = i.node.firstChild;
        if (l && u && c) {
          const p = {
            index: c.attrs.index,
            level: c.attrs.level,
            type: c.type.name,
            depth: n.doc.resolve(i.pos).depth
          };
          let m = {
            index: u.attrs.index,
            level: u.attrs.level,
            type: u.type.name,
            depth: o.doc.resolve(l.pos).depth
          };
          r[i.node.attrs.id] = m, t.getMeta("numberedListIndexing") && (i.node.attrs.id in e.prevTransactionOldBlockAttrs && (m = e.prevTransactionOldBlockAttrs[i.node.attrs.id]), p.type === "numberedListItem" && (m.index = p.index)), e.currentTransactionOldBlockAttrs[i.node.attrs.id] = m, JSON.stringify(m) !== JSON.stringify(p) && (m["depth-change"] = m.depth - p.depth, e.updatedBlocks.add(i.node.attrs.id));
        }
      }
      return e.prevTransactionOldBlockAttrs = r, e;
    }
  },
  props: {
    decorations(t) {
      const e = this.getState(t);
      if (e.updatedBlocks.size === 0)
        return;
      const o = [];
      return t.doc.descendants((n, r) => {
        if (!n.attrs.id || !e.updatedBlocks.has(n.attrs.id))
          return;
        const a = e.currentTransactionOldBlockAttrs[n.attrs.id], d = {};
        for (let [i, l] of Object.entries(a))
          d["data-prev-" + Be[i]] = l || "none";
        const s = N.node(r, r + n.nodeSize, {
          ...d
        });
        o.push(s);
      }), L.create(t.doc, o);
    }
  }
}), Te = "_blockOuter_1ltqa_5", we = "_block_1ltqa_5", xe = "_blockContent_1ltqa_19", Ie = "_blockGroup_1ltqa_47", Ae = "_isEmpty_1ltqa_232", Pe = "_isFilter_1ltqa_233", Se = "_hasAnchor_1ltqa_246", y = {
  blockOuter: Te,
  block: we,
  blockContent: xe,
  blockGroup: Ie,
  isEmpty: Ae,
  isFilter: Pe,
  hasAnchor: Se
}, Ee = {
  blockColor: "data-block-color",
  blockStyle: "data-block-style",
  id: "data-id",
  depth: "data-depth",
  depthChange: "data-depth-change"
}, He = x.create({
  name: "blockContainer",
  group: "blockContainer",
  content: "blockContent blockGroup?",
  priority: 50,
  defining: !0,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (t) => {
          if (typeof t == "string")
            return !1;
          const e = {};
          for (let [o, n] of Object.entries(Ee))
            t.getAttribute(n) && (e[o] = t.getAttribute(n));
          return t.getAttribute("data-node-type") === "blockContainer" ? e : !1;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "div",
      w(t, {
        class: y.blockOuter,
        "data-node-type": "block-outer"
      }),
      [
        "div",
        w(t, {
          class: y.block,
          "data-node-type": this.name
        }),
        0
      ]
    ];
  },
  addCommands() {
    return {
      BNCreateBlock: (t) => ({ state: e, dispatch: o }) => {
        const n = e.schema.nodes.blockContainer.createAndFill();
        return o && e.tr.insert(t, n), !0;
      },
      BNDeleteBlock: (t) => ({ state: e, view: o, dispatch: n }) => {
        const r = f(e.doc, t);
        if (r === void 0)
          return !1;
        const { startPos: a, endPos: d } = r;
        return n && (e.tr.deleteRange(a, d), e.tr.setSelection(
          new F(e.doc.resolve(a + 1))
        ), o.focus()), !0;
      },
      BNMergeBlocks: (t) => ({ state: e, dispatch: o }) => {
        const n = e.doc.resolve(t + 1).node().type.name === "blockContainer", r = e.doc.resolve(t - 1).node().type.name === "blockContainer";
        if (!n || !r)
          return !1;
        const a = f(
          e.doc,
          t + 1
        ), { node: d, contentNode: s, startPos: i, endPos: l, depth: u } = a;
        if (d.childCount === 2) {
          const m = e.doc.resolve(
            i + s.nodeSize + 1
          ), k = e.doc.resolve(l - 1), b = m.blockRange(k);
          o && e.tr.lift(b, u - 1);
        }
        let c = t - 1, p = f(e.doc, c);
        for (; p.numChildBlocks > 0; )
          if (c--, p = f(e.doc, c), p === void 0)
            return !1;
        return o && (e.tr.deleteRange(i, i + s.nodeSize), e.tr.insertText(s.textContent, c - 1), e.tr.setSelection(
          new F(e.doc.resolve(c - 1))
        )), !0;
      },
      BNSplitBlock: (t, e) => ({ state: o, dispatch: n }) => {
        const r = f(o.doc, t);
        if (r === void 0)
          return !1;
        const { contentNode: a, contentType: d, startPos: s, endPos: i, depth: l } = r, u = o.doc.cut(s + 1, t), c = o.doc.cut(t, i - 1), p = o.schema.nodes.blockContainer.createAndFill(), m = i + 1, k = m + 2;
        return n && (o.tr.insert(m, p), o.tr.replace(
          k,
          k + 1,
          c.content.size > 0 ? new E(
            H.from(c),
            l + 2,
            l + 2
          ) : void 0
        ), e && o.tr.setBlockType(
          k,
          k,
          o.schema.node(d).type,
          a.attrs
        ), o.tr.setSelection(
          new F(o.doc.resolve(k))
        ), o.tr.replace(
          s + 1,
          i - 1,
          u.content.size > 0 ? new E(
            H.from(u),
            l + 2,
            l + 2
          ) : void 0
        )), !0;
      },
      BNUpdateBlock: (t, e) => ({ state: o, dispatch: n }) => {
        const r = f(o.doc, t);
        if (r === void 0)
          return !1;
        const { node: a, startPos: d, contentNode: s } = r;
        return n && o.tr.setBlockType(
          d + 1,
          d + s.nodeSize + 1,
          o.schema.node(e.type).type,
          {
            ...a.attrs,
            ...e.props
          }
        ), !0;
      },
      BNCreateOrUpdateBlock: (t, e) => ({ state: o, chain: n }) => {
        const r = f(o.doc, t);
        if (r === void 0)
          return !1;
        const { node: a, startPos: d, endPos: s } = r;
        if (a.textContent.length === 0) {
          const i = d + 1;
          return n().BNUpdateBlock(t, e).setTextSelection(i).run();
        } else {
          const i = s + 1, l = i + 1;
          return n().BNCreateBlock(i).BNUpdateBlock(l, e).setTextSelection(l).run();
        }
      }
    };
  },
  addProseMirrorPlugins() {
    return [Me()];
  },
  addKeyboardShortcuts() {
    return {
      Backspace: () => this.editor.commands.first(({ commands: o }) => [
        () => o.deleteSelection(),
        () => o.undoInputRule(),
        () => o.command(({ state: n }) => {
          const { contentType: r } = f(
            n.doc,
            n.selection.from
          ), a = n.selection.$anchor.parentOffset === 0, d = r.name === "paragraph";
          return a && !d ? o.BNUpdateBlock(n.selection.from, {
            type: "paragraph",
            props: {}
          }) : !1;
        }),
        () => o.command(({ state: n }) => n.selection.$anchor.parentOffset === 0 ? o.liftListItem("blockContainer") : !1),
        () => o.command(({ state: n }) => {
          const { depth: r, startPos: a } = f(
            n.doc,
            n.selection.from
          ), d = n.selection.$anchor.parentOffset === 0, s = n.selection.anchor === n.selection.head, i = a === 2, l = a - 1;
          return !i && d && s && r === 2 ? o.BNMergeBlocks(l) : !1;
        })
      ]),
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.command(({ state: n }) => {
          const { node: r, depth: a } = f(
            n.doc,
            n.selection.from
          ), d = n.selection.$anchor.parentOffset === 0, s = n.selection.anchor === n.selection.head, i = r.textContent.length === 0, l = a > 2;
          return d && s && i && l ? o.liftListItem("blockContainer") : !1;
        }),
        () => o.command(({ state: n, chain: r }) => {
          const { node: a, endPos: d } = f(
            n.doc,
            n.selection.from
          ), s = n.selection.$anchor.parentOffset === 0, i = n.selection.anchor === n.selection.head, l = a.textContent.length === 0;
          if (s && i && l) {
            const u = d + 1, c = u + 2;
            return r().BNCreateBlock(u).setTextSelection(c).run(), !0;
          }
          return !1;
        }),
        () => o.command(({ state: n, chain: r }) => {
          const { node: a } = f(
            n.doc,
            n.selection.from
          );
          return a.textContent.length === 0 ? !1 : (r().deleteSelection().BNSplitBlock(n.selection.from, !1).run(), !0);
        })
      ]),
      Tab: () => (this.editor.commands.sinkListItem("blockContainer"), !0),
      "Shift-Tab": () => (this.editor.commands.liftListItem("blockContainer"), !0),
      "Mod-Alt-0": () => this.editor.commands.BNCreateBlock(
        this.editor.state.selection.anchor + 2
      ),
      "Mod-Alt-1": () => this.editor.commands.BNUpdateBlock(this.editor.state.selection.anchor, {
        type: "heading",
        props: {
          level: "1"
        }
      }),
      "Mod-Alt-2": () => this.editor.commands.BNUpdateBlock(this.editor.state.selection.anchor, {
        type: "heading",
        props: {
          level: "2"
        }
      }),
      "Mod-Alt-3": () => this.editor.commands.BNUpdateBlock(this.editor.state.selection.anchor, {
        type: "heading",
        props: {
          level: "3"
        }
      }),
      "Mod-Shift-7": () => this.editor.commands.BNUpdateBlock(this.editor.state.selection.anchor, {
        type: "bulletListItem",
        props: {}
      }),
      "Mod-Shift-8": () => this.editor.commands.BNUpdateBlock(this.editor.state.selection.anchor, {
        type: "numberedListItem",
        props: {}
      })
    };
  }
}), Ne = x.create({
  name: "blockGroup",
  group: "blockGroup",
  content: "blockContainer+",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (t) => typeof t == "string" ? !1 : t.getAttribute("data-node-type") === "blockGroup" ? null : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "div",
      w(this.options.HTMLAttributes, t, {
        class: y.blockGroup,
        "data-node-type": "blockGroup"
      }),
      0
    ];
  }
}), Le = x.create({
  name: "paragraph",
  group: "blockContent",
  content: "inline*",
  parseHTML() {
    return [
      {
        tag: "p",
        priority: 200,
        node: "blockContainer"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "div",
      w(t, {
        class: y.blockContent,
        "data-content-type": this.name
      }),
      ["p", 0]
    ];
  }
}), Oe = x.create({
  name: "heading",
  group: "blockContent",
  content: "inline*",
  addAttributes() {
    return {
      level: {
        default: "1",
        parseHTML: (t) => t.getAttribute("data-level"),
        renderHTML: (t) => ({
          "data-level": t.level
        })
      }
    };
  },
  addInputRules() {
    return [
      ...["1", "2", "3"].map((t) => new q({
        find: new RegExp(`^(#{${parseInt(t)}})\\s$`),
        handler: ({ state: e, chain: o, range: n }) => {
          o().BNUpdateBlock(e.selection.from, {
            type: "heading",
            props: {
              level: t
            }
          }).deleteRange({ from: n.from, to: n.to });
        }
      }))
    ];
  },
  parseHTML() {
    return [
      {
        tag: "h1",
        attrs: { level: "1" },
        node: "blockContainer"
      },
      {
        tag: "h2",
        attrs: { level: "2" },
        node: "blockContainer"
      },
      {
        tag: "h3",
        attrs: { level: "3" },
        node: "blockContainer"
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "div",
      w(e, {
        class: y.blockContent,
        "data-content-type": this.name
      }),
      ["h" + t.attrs.level, 0]
    ];
  }
}), Q = (t) => {
  const { node: e, contentType: o } = f(
    t.state.doc,
    t.state.selection.from
  ), n = t.state.selection.anchor === t.state.selection.head;
  return !o.name.endsWith("ListItem") || !n ? !1 : t.commands.first(({ state: r, chain: a, commands: d }) => [
    () => d.command(() => e.textContent.length === 0 ? d.BNUpdateBlock(r.selection.from, {
      type: "paragraph",
      props: {}
    }) : !1),
    () => d.command(() => e.textContent.length > 0 ? (a().deleteSelection().BNSplitBlock(r.selection.from, !0).run(), !0) : !1)
  ]);
}, Re = x.create({
  name: "bulletListItem",
  group: "blockContent",
  content: "inline*",
  addInputRules() {
    return [
      new q({
        find: new RegExp("^[-+*]\\s$"),
        handler: ({ state: t, chain: e, range: o }) => {
          e().BNUpdateBlock(t.selection.from, {
            type: "bulletListItem",
            props: {}
          }).deleteRange({ from: o.from, to: o.to });
        }
      })
    ];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => Q(this.editor)
    };
  },
  parseHTML() {
    return [
      {
        tag: "li",
        getAttrs: (t) => {
          if (typeof t == "string")
            return !1;
          const e = t.parentElement;
          return e === null ? !1 : e.getAttribute("data-content-type") === "bulletListItem" ? {} : e.tagName === "UL" ? {} : !1;
        },
        node: "blockContainer"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "div",
      w(t, {
        class: y.blockContent,
        "data-content-type": this.name
      }),
      ["li", 0]
    ];
  }
}), Fe = new v("numbered-list-indexing"), _e = () => new B({
  key: Fe,
  appendTransaction: (t, e, o) => {
    const n = o.tr;
    n.setMeta("numberedListIndexing", !0);
    let r = !1;
    return o.doc.descendants((a, d) => {
      if (a.type.name === "blockContainer" && a.firstChild.type.name === "numberedListItem") {
        let s = "1";
        const i = d === 1, l = f(n.doc, d + 1);
        if (l === void 0)
          return;
        if (!i) {
          const p = f(n.doc, d - 2);
          if (p === void 0)
            return;
          if (!(l.depth !== p.depth)) {
            const k = p.contentNode;
            if (p.contentType.name === "numberedListItem") {
              const O = k.attrs.index;
              s = (parseInt(O) + 1).toString();
            }
          }
        }
        l.contentNode.attrs.index !== s && (r = !0, n.setNodeMarkup(d + 1, void 0, {
          index: s
        }));
      }
    }), r ? n : null;
  }
}), De = x.create({
  name: "numberedListItem",
  group: "blockContent",
  content: "inline*",
  addAttributes() {
    return {
      index: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-index"),
        renderHTML: (t) => ({
          "data-index": t.index
        })
      }
    };
  },
  addInputRules() {
    return [
      new q({
        find: new RegExp("^1\\.\\s$"),
        handler: ({ state: t, chain: e, range: o }) => {
          e().BNUpdateBlock(t.selection.from, {
            type: "numberedListItem",
            props: {}
          }).deleteRange({ from: o.from, to: o.to });
        }
      })
    ];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => Q(this.editor)
    };
  },
  addProseMirrorPlugins() {
    return [_e()];
  },
  parseHTML() {
    return [
      {
        tag: "li",
        getAttrs: (t) => {
          if (typeof t == "string")
            return !1;
          const e = t.parentElement;
          return e === null ? !1 : e.getAttribute("data-content-type") === "numberedListItem" ? {} : e.tagName === "OL" ? {} : !1;
        },
        node: "blockContainer"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "div",
      w(t, {
        class: y.blockContent,
        "data-content-type": this.name
      }),
      ["li", 0]
    ];
  }
}), Ue = [
  Le,
  Oe,
  Re,
  De,
  He,
  Ne,
  x.create({
    name: "doc",
    topNode: !0,
    content: "blockGroup"
  })
];
class ze {
  constructor({
    editor: e,
    formattingToolbarFactory: o,
    view: n,
    shouldShow: r
  }) {
    h(this, "editor");
    h(this, "view");
    h(this, "formattingToolbar");
    h(this, "preventHide", !1);
    h(this, "preventShow", !1);
    h(this, "toolbarIsOpen", !1);
    h(this, "shouldShow", ({ view: e, state: o, from: n, to: r }) => {
      const { doc: a, selection: d } = o, { empty: s } = d, i = !a.textBetween(n, r).length && oe(o.selection);
      return !(!e.hasFocus() || s || i);
    });
    h(this, "viewMousedownHandler", () => {
      this.preventShow = !0;
    });
    h(this, "viewMouseupHandler", () => {
      this.preventShow = !1, setTimeout(() => this.update(this.editor.view));
    });
    h(this, "dragstartHandler", () => {
      this.formattingToolbar.hide(), this.toolbarIsOpen = !1;
    });
    h(this, "focusHandler", () => {
      setTimeout(() => this.update(this.editor.view));
    });
    h(this, "blurHandler", ({ event: e }) => {
      var o, n;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      (e == null ? void 0 : e.relatedTarget) && ((n = (o = this.formattingToolbar.element) == null ? void 0 : o.parentNode) == null ? void 0 : n.contains(
        e.relatedTarget
      )) || this.toolbarIsOpen && (this.formattingToolbar.hide(), this.toolbarIsOpen = !1);
    });
    this.editor = e, this.view = n, this.formattingToolbar = o(this.getStaticParams()), r && (this.shouldShow = r), this.view.dom.addEventListener("mousedown", this.viewMousedownHandler), this.view.dom.addEventListener("mouseup", this.viewMouseupHandler), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler);
  }
  update(e, o) {
    var p;
    const { state: n, composing: r } = e, { doc: a, selection: d } = n, s = o && o.doc.eq(a) && o.selection.eq(d);
    if (r || s)
      return;
    const { ranges: i } = d, l = Math.min(...i.map((m) => m.$from.pos)), u = Math.max(...i.map((m) => m.$to.pos)), c = (p = this.shouldShow) == null ? void 0 : p.call(this, {
      editor: this.editor,
      view: e,
      state: n,
      oldState: o,
      from: l,
      to: u
    });
    if (!this.toolbarIsOpen && !this.preventShow && (c || this.preventHide)) {
      this.formattingToolbar.render(this.getDynamicParams(), !0), this.toolbarIsOpen = !0, this.formattingToolbar.element.addEventListener(
        "mousedown",
        (m) => m.preventDefault()
      );
      return;
    }
    if (this.toolbarIsOpen && !this.preventShow && (c || this.preventHide)) {
      this.formattingToolbar.render(this.getDynamicParams(), !1);
      return;
    }
    if (this.toolbarIsOpen && !this.preventHide && (!c || this.preventShow)) {
      this.formattingToolbar.hide(), this.toolbarIsOpen = !1, this.formattingToolbar.element.removeEventListener(
        "mousedown",
        (m) => m.preventDefault()
      );
      return;
    }
  }
  destroy() {
    this.view.dom.removeEventListener("mousedown", this.viewMousedownHandler), this.view.dom.removeEventListener("mouseup", this.viewMouseupHandler), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
  getSelectionBoundingBox() {
    const { state: e } = this.editor.view, { selection: o } = e, { ranges: n } = o, r = Math.min(...n.map((d) => d.$from.pos)), a = Math.max(...n.map((d) => d.$to.pos));
    if (ne(o)) {
      const d = this.editor.view.nodeDOM(r);
      if (d)
        return d.getBoundingClientRect();
    }
    return j(this.editor.view, r, a);
  }
  getStaticParams() {
    return {
      toggleBold: () => {
        this.editor.view.focus(), this.editor.commands.toggleBold();
      },
      toggleItalic: () => {
        this.editor.view.focus(), this.editor.commands.toggleItalic();
      },
      toggleUnderline: () => {
        this.editor.view.focus(), this.editor.commands.toggleUnderline();
      },
      toggleStrike: () => {
        this.editor.view.focus(), this.editor.commands.toggleStrike();
      },
      setHyperlink: (e, o) => {
        if (e === "")
          return;
        let { from: n, to: r } = this.editor.state.selection;
        o || (o = this.editor.state.doc.textBetween(n, r));
        const a = this.editor.schema.mark("link", { href: e });
        this.editor.view.dispatch(
          this.editor.view.state.tr.insertText(o, n, r).addMark(n, n + o.length, a)
        ), this.editor.view.focus();
      },
      setTextColor: (e) => {
        this.editor.view.focus(), this.editor.commands.setTextColor(e);
      },
      setBackgroundColor: (e) => {
        this.editor.view.focus(), this.editor.commands.setBackgroundColor(e);
      },
      setTextAlignment: (e) => {
        this.editor.view.focus(), this.editor.commands.setTextAlignment(e);
      },
      increaseBlockIndent: () => {
        this.editor.view.focus(), this.editor.commands.sinkListItem("blockContainer");
      },
      decreaseBlockIndent: () => {
        this.editor.view.focus(), this.editor.commands.liftListItem("blockContainer");
      },
      updateBlock: (e) => {
        this.editor.view.focus(), this.editor.commands.BNUpdateBlock(
          this.editor.state.selection.from,
          e
        );
      }
    };
  }
  getDynamicParams() {
    const e = f(
      this.editor.state.doc,
      this.editor.state.selection.from
    );
    return {
      boldIsActive: this.editor.isActive("bold"),
      italicIsActive: this.editor.isActive("italic"),
      underlineIsActive: this.editor.isActive("underline"),
      strikeIsActive: this.editor.isActive("strike"),
      hyperlinkIsActive: this.editor.isActive("link"),
      activeHyperlinkUrl: this.editor.getAttributes("link").href || "",
      activeHyperlinkText: this.editor.state.doc.textBetween(
        this.editor.state.selection.from,
        this.editor.state.selection.to
      ),
      textColor: this.editor.getAttributes("textColor").color || "default",
      backgroundColor: this.editor.getAttributes("backgroundColor").color || "default",
      textAlignment: this.editor.getAttributes(e.contentType).textAlignment || "left",
      canIncreaseBlockIndent: this.editor.state.doc.resolve(e.startPos).index(e.depth - 1) > 0,
      canDecreaseBlockIndent: e.depth > 2,
      block: {
        type: e.contentType.name,
        props: e.contentNode.attrs
      },
      referenceRect: this.getSelectionBoundingBox()
    };
  }
}
const qe = (t) => new B({
  key: new v("FormattingToolbarPlugin"),
  view: (e) => new ze({ view: e, ...t })
}), $e = C.create({
  name: "FormattingToolbarExtension",
  addProseMirrorPlugins() {
    if (!this.options.formattingToolbarFactory)
      throw new Error(
        "UI Element factory not defined for FormattingToolbarExtension"
      );
    return [
      qe({
        editor: this.editor,
        formattingToolbarFactory: this.options.formattingToolbarFactory,
        pluginKey: new v("FormattingToolbarPlugin")
      })
    ];
  }
}), Ge = "_bnEditor_xixap_3", Ve = "_bnRoot_xixap_13", We = "_dragPreview_xixap_27", U = {
  bnEditor: Ge,
  bnRoot: Ve,
  dragPreview: We
}, Ye = re(
  (t) => t.type.name === "blockContainer"
);
function z() {
  return {
    active: !1,
    triggerCharacter: void 0,
    queryStartPos: void 0,
    items: [],
    keyboardHoveredItemIndex: void 0,
    notFoundCount: 0,
    decorationId: void 0
  };
}
class je {
  constructor({
    editor: e,
    pluginKey: o,
    onSelectItem: n = () => {
    },
    suggestionsMenuFactory: r
  }) {
    h(this, "editor");
    h(this, "pluginKey");
    h(this, "suggestionsMenu");
    h(this, "pluginState");
    h(this, "itemCallback");
    this.editor = e, this.pluginKey = o, this.pluginState = z(), this.itemCallback = (a) => n({
      item: a,
      editor: e,
      range: {
        from: this.pluginState.queryStartPos - this.pluginState.triggerCharacter.length,
        to: e.state.selection.from
      }
    }), this.suggestionsMenu = r(this.getStaticParams());
  }
  update(e, o) {
    const n = this.pluginKey.getState(o), r = this.pluginKey.getState(e.state), a = !n.active && r.active, d = n.active && !r.active, s = n.active && r.active;
    !a && !s && !d || (this.pluginState = d ? n : r, d && (this.suggestionsMenu.hide(), this.suggestionsMenu.element.removeEventListener(
      "mousedown",
      (i) => i.preventDefault()
    )), s && this.suggestionsMenu.render(this.getDynamicParams(), !1), a && (this.suggestionsMenu.render(this.getDynamicParams(), !0), this.suggestionsMenu.element.addEventListener(
      "mousedown",
      (i) => i.preventDefault()
    )));
  }
  getStaticParams() {
    return {
      itemCallback: (e) => this.itemCallback(e)
    };
  }
  getDynamicParams() {
    const e = document.querySelector(
      `[data-decoration-id="${this.pluginState.decorationId}"]`
    );
    return {
      items: this.pluginState.items,
      keyboardHoveredItemIndex: this.pluginState.keyboardHoveredItemIndex,
      referenceRect: e.getBoundingClientRect()
    };
  }
}
function Ke({
  pluginKey: t,
  editor: e,
  defaultTriggerCharacter: o,
  suggestionsMenuFactory: n,
  onSelectItem: r = () => {
  },
  items: a = () => []
}) {
  if (o.length !== 1)
    throw new Error("'char' should be a single character");
  const d = (s) => {
    s.dispatch(s.state.tr.setMeta(t, { deactivate: !0 }));
  };
  return new B({
    key: t,
    view: (s) => new je({
      editor: e,
      pluginKey: t,
      onSelectItem: (i) => {
        d(s), r(i);
      },
      suggestionsMenuFactory: n
    }),
    state: {
      init() {
        return z();
      },
      apply(s, i, l, u) {
        var p, m, k, b;
        if (s.getMeta("orderedListIndexing") !== void 0)
          return i;
        if ((p = s.getMeta(t)) != null && p.activate)
          return {
            active: !0,
            triggerCharacter: ((m = s.getMeta(t)) == null ? void 0 : m.triggerCharacter) || "",
            queryStartPos: u.selection.from,
            items: a(""),
            keyboardHoveredItemIndex: 0,
            notFoundCount: 0,
            decorationId: `id_${Math.floor(Math.random() * 4294967295)}`
          };
        if (!i.active)
          return i;
        const c = { ...i };
        if (c.items = a(
          u.doc.textBetween(i.queryStartPos, u.selection.from)
        ), c.notFoundCount = 0, c.items.length === 0 && (c.notFoundCount = Math.max(
          0,
          i.notFoundCount + (u.selection.from - l.selection.from)
        )), u.selection.from !== u.selection.to || ((k = s.getMeta(t)) == null ? void 0 : k.deactivate) || s.getMeta("focus") || s.getMeta("blur") || s.getMeta("pointer") || i.active && u.selection.from < i.queryStartPos || c.notFoundCount > 3)
          return z();
        if (((b = s.getMeta(t)) == null ? void 0 : b.selectedItemIndexChanged) !== void 0) {
          let g = s.getMeta(t).selectedItemIndexChanged;
          g < 0 ? g = i.items.length - 1 : g >= i.items.length && (g = 0), c.keyboardHoveredItemIndex = g;
        }
        return c;
      }
    },
    props: {
      handleKeyDown(s, i) {
        const l = this.getState(s.state).active;
        if (i.key === o && !l)
          return s.dispatch(
            s.state.tr.insertText(o).scrollIntoView().setMeta(t, {
              activate: !0,
              triggerCharacter: o
            })
          ), !0;
        if (!l)
          return !1;
        const {
          triggerCharacter: u,
          queryStartPos: c,
          items: p,
          keyboardHoveredItemIndex: m
        } = t.getState(s.state);
        return i.key === "ArrowUp" ? (s.dispatch(
          s.state.tr.setMeta(t, {
            selectedItemIndexChanged: m - 1
          })
        ), !0) : i.key === "ArrowDown" ? (s.dispatch(
          s.state.tr.setMeta(t, {
            selectedItemIndexChanged: m + 1
          })
        ), !0) : i.key === "Enter" ? (d(s), r({
          item: p[m],
          editor: e,
          range: {
            from: c - u.length,
            to: s.state.selection.from
          }
        }), !0) : i.key === "Escape" ? (d(s), !0) : !1;
      },
      handleClick(s) {
        d(s);
      },
      decorations(s) {
        const { active: i, decorationId: l, queryStartPos: u, triggerCharacter: c } = this.getState(s);
        if (!i)
          return null;
        if (c === "") {
          const p = Ye(s.selection);
          if (p)
            return L.create(s.doc, [
              N.node(
                p.pos,
                p.pos + p.node.nodeSize,
                {
                  nodeName: "span",
                  class: "suggestion-decorator",
                  "data-decoration-id": l
                }
              )
            ]);
        }
        return L.create(s.doc, [
          N.inline(
            u - c.length,
            u,
            {
              nodeName: "span",
              class: "suggestion-decorator",
              "data-decoration-id": l
            }
          )
        ]);
      }
    }
  });
}
class I {
  constructor(e, o, n = []) {
    this.name = e, this.execute = o, this.aliases = n;
  }
  match(e) {
    return this.name.toLowerCase().startsWith(e.toLowerCase()) || this.aliases.filter(
      (o) => o.toLowerCase().startsWith(e.toLowerCase())
    ).length !== 0;
  }
}
const Je = {
  heading: new I(
    "Heading",
    (t, e) => t.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "heading",
      props: {
        level: "1"
      }
    }).run(),
    ["h", "heading1", "h1"]
  ),
  heading2: new I(
    "Heading 2",
    (t, e) => t.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "heading",
      props: {
        level: "2"
      }
    }).run(),
    ["h2", "heading2", "subheading"]
  ),
  heading3: new I(
    "Heading 3",
    (t, e) => t.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "heading",
      props: {
        level: "3"
      }
    }).run(),
    ["h3", "heading3", "subheading"]
  ),
  numberedList: new I(
    "Numbered List",
    (t, e) => t.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "numberedListItem",
      props: {}
    }).run(),
    ["li", "list", "numberedlist", "numbered list"]
  ),
  bulletList: new I(
    "Bullet List",
    (t, e) => t.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "bulletListItem",
      props: {}
    }).run(),
    ["ul", "list", "bulletlist", "bullet list"]
  ),
  paragraph: new I(
    "Paragraph",
    (t, e) => t.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "paragraph",
      props: {}
    }).run(),
    ["p"]
  )
}, $ = new v("suggestions-slash-commands"), Qe = C.create({
  name: "slash-command",
  addOptions() {
    return {
      commands: Je,
      slashMenuFactory: void 0
    };
  },
  addProseMirrorPlugins() {
    if (!this.options.slashMenuFactory)
      throw new Error("UI Element factory not defined for SlashMenuExtension");
    return [
      Ke({
        pluginKey: $,
        editor: this.editor,
        defaultTriggerCharacter: "/",
        suggestionsMenuFactory: this.options.slashMenuFactory,
        items: (t) => {
          const e = [];
          for (const o in this.options.commands)
            e.push(this.options.commands[o]);
          return e.filter((o) => o.match(t));
        },
        onSelectItem: ({ item: t, editor: e, range: o }) => {
          t.execute(e, o);
        }
      })
    ];
  }
});
class P extends _ {
  constructor(o, n) {
    super(o, n);
    h(this, "nodes");
    const r = o.node();
    this.nodes = [], o.doc.nodesBetween(o.pos, n.pos, (a, d, s) => {
      if (s !== null && s.eq(r))
        return this.nodes.push(a), !1;
    });
  }
  static create(o, n, r = n) {
    return new P(o.resolve(n), o.resolve(r));
  }
  content() {
    return new E(H.from(this.nodes), 0, 0);
  }
  eq(o) {
    if (!(o instanceof P) || this.nodes.length !== o.nodes.length || this.from !== o.from || this.to !== o.to)
      return !1;
    for (let n = 0; n < this.nodes.length; n++)
      if (!this.nodes[n].eq(o.nodes[n]))
        return !1;
    return !0;
  }
  map(o, n) {
    let r = n.mapResult(this.from), a = n.mapResult(this.to);
    return a.deleted ? _.near(o.resolve(r.pos)) : r.deleted ? _.near(o.resolve(a.pos)) : new P(
      o.resolve(r.pos),
      o.resolve(a.pos)
    );
  }
  toJSON() {
    return { type: "node", anchor: this.anchor, head: this.head };
  }
}
const Xe = ve.__serializeForClipboard;
let T;
function X(t, e) {
  var r;
  let o = e.posAtCoords(t);
  if (!o)
    return;
  let n = e.domAtPos(o.pos).node;
  if (n !== e.dom) {
    for (; n && n.parentNode && n.parentNode !== e.dom && !((r = n.hasAttribute) != null && r.call(n, "data-id")); )
      n = n.parentNode;
    if (!!n)
      return { node: n, id: n.getAttribute("data-id") };
  }
}
function Ze(t, e) {
  let o = X(t, e);
  if (o && o.node.nodeType === 1) {
    const n = e.docView;
    let r = n.nearestDesc(o.node, !0);
    return !r || r === n ? null : r.posBefore;
  }
  return null;
}
function et(t, e) {
  let o, n;
  const r = e.resolve(t.from).node().type.spec.group === "blockContent", a = e.resolve(t.to).node().type.spec.group === "blockContent", d = Math.min(t.$anchor.depth, t.$head.depth);
  if (r && a) {
    const s = t.$from.start(d - 1), i = t.$to.end(d - 1);
    o = e.resolve(s - 1).pos, n = e.resolve(i + 1).pos;
  } else
    o = t.from, n = t.to;
  return { from: o, to: n };
}
function Y(t, e, o = e) {
  e === o && (o += t.state.doc.resolve(e + 1).node().nodeSize);
  const n = t.domAtPos(e).node.cloneNode(!0), r = t.domAtPos(e).node, a = (i, l) => Array.prototype.indexOf.call(i.children, l), d = a(
    r,
    t.domAtPos(e + 1).node.parentElement
  ), s = a(
    r,
    t.domAtPos(o - 1).node.parentElement
  );
  for (let i = r.childElementCount - 1; i >= 0; i--)
    (i > s || i < d) && n.removeChild(n.children[i]);
  T = n, T.className = U.dragPreview, document.body.appendChild(T);
}
function tt() {
  T !== void 0 && (document.body.removeChild(T), T = void 0);
}
function ot(t, e) {
  if (!t.dataTransfer)
    return;
  const o = e.dom.getBoundingClientRect();
  let n = {
    left: o.left + o.width / 2,
    top: t.clientY
  }, r = Ze(n, e);
  if (r != null) {
    const a = e.state.selection, d = e.state.doc, { from: s, to: i } = et(a, d), l = s <= r && r < i, u = !a.$anchor.node().eq(a.$head.node());
    l && u ? (e.dispatch(
      e.state.tr.setSelection(P.create(d, s, i))
    ), Y(e, s, i)) : (e.dispatch(
      e.state.tr.setSelection(ye.create(e.state.doc, r))
    ), Y(e, r));
    let c = e.state.selection.content(), { dom: p, text: m } = Xe(e, c);
    t.dataTransfer.clearData(), t.dataTransfer.setData("text/html", p.innerHTML), t.dataTransfer.setData("text/plain", m), t.dataTransfer.effectAllowed = "move", t.dataTransfer.setDragImage(T, 0, 0), e.dragging = { slice: c, move: !0 };
  }
}
class nt {
  constructor({
    editor: e,
    blockMenuFactory: o,
    horizontalPosAnchoredAtRoot: n
  }) {
    h(this, "editor");
    h(this, "horizontalPosAnchoredAtRoot");
    h(this, "horizontalPosAnchor");
    h(this, "blockMenu");
    h(this, "hoveredBlockContent");
    h(this, "menuOpen", !1);
    h(this, "menuFrozen", !1);
    this.editor = e, this.horizontalPosAnchoredAtRoot = n, this.horizontalPosAnchor = e.view.dom.firstChild.getBoundingClientRect().x, this.blockMenu = o(this.getStaticParams()), document.body.addEventListener(
      "mousemove",
      (r) => {
        var l, u;
        if (this.menuFrozen)
          return;
        const a = this.editor.view.dom.firstChild.getBoundingClientRect();
        this.horizontalPosAnchor = a.x;
        const d = {
          left: a.left + a.width / 2,
          top: r.clientY
        }, s = X(d, this.editor.view);
        if (!s) {
          this.menuOpen && (this.menuOpen = !1, this.blockMenu.hide());
          return;
        }
        if (this.menuOpen && ((l = this.hoveredBlockContent) == null ? void 0 : l.hasAttribute("data-id")) && ((u = this.hoveredBlockContent) == null ? void 0 : u.getAttribute("data-id")) === s.id)
          return;
        const i = s.node.firstChild;
        this.hoveredBlockContent = i, i && (this.menuOpen ? this.blockMenu.render(this.getDynamicParams(), !1) : (this.menuOpen = !0, this.blockMenu.render(this.getDynamicParams(), !0)));
      },
      !0
    ), document.body.addEventListener(
      "mousedown",
      (r) => {
        var a;
        (a = this.blockMenu.element) != null && a.contains(r.target) || (this.menuOpen && (this.menuOpen = !1, this.blockMenu.hide()), this.menuFrozen = !1);
      },
      !0
    ), document.body.addEventListener(
      "keydown",
      () => {
        this.menuOpen && (this.menuOpen = !1, this.blockMenu.hide()), this.menuFrozen = !1;
      },
      !0
    );
  }
  destroy() {
    this.menuOpen && (this.menuOpen = !1, this.blockMenu.hide());
  }
  addBlock() {
    this.menuOpen = !1, this.menuFrozen = !0, this.blockMenu.hide();
    const e = this.hoveredBlockContent.getBoundingClientRect(), o = this.editor.view.posAtCoords({
      left: e.left + e.width / 2,
      top: e.top + e.height / 2
    });
    if (!o)
      return;
    const n = f(this.editor.state.doc, o.pos);
    if (n === void 0)
      return;
    const { contentNode: r, endPos: a } = n;
    if (r.textContent.length !== 0) {
      const d = a + 1, s = d + 2;
      this.editor.chain().BNCreateBlock(d).BNUpdateBlock(s, { type: "paragraph", props: {} }).setTextSelection(s).run();
    } else
      this.editor.commands.setTextSelection(a);
    this.editor.view.focus(), this.editor.view.dispatch(
      this.editor.view.state.tr.scrollIntoView().setMeta($, {
        activate: !0,
        type: "drag"
      })
    );
  }
  deleteBlock() {
    this.menuOpen = !1, this.blockMenu.hide();
    const e = this.hoveredBlockContent.getBoundingClientRect(), o = this.editor.view.posAtCoords({
      left: e.left + e.width / 2,
      top: e.top + e.height / 2
    });
    !o || this.editor.commands.BNDeleteBlock(o.pos);
  }
  setBlockBackgroundColor(e) {
    this.menuOpen = !1, this.blockMenu.hide();
    const o = this.hoveredBlockContent.getBoundingClientRect(), n = this.editor.view.posAtCoords({
      left: o.left + o.width / 2,
      top: o.top + o.height / 2
    });
    !n || this.editor.commands.setBlockBackgroundColor(n.pos, e);
  }
  setBlockTextColor(e) {
    this.menuOpen = !1, this.blockMenu.hide();
    const o = this.hoveredBlockContent.getBoundingClientRect(), n = this.editor.view.posAtCoords({
      left: o.left + o.width / 2,
      top: o.top + o.height / 2
    });
    !n || this.editor.commands.setBlockTextColor(n.pos, e);
  }
  getStaticParams() {
    return {
      addBlock: () => this.addBlock(),
      deleteBlock: () => this.deleteBlock(),
      blockDragStart: (e) => ot(e, this.editor.view),
      blockDragEnd: () => tt(),
      freezeMenu: () => {
        this.menuFrozen = !0;
      },
      unfreezeMenu: () => {
        this.menuFrozen = !1;
      },
      setBlockBackgroundColor: (e) => this.setBlockBackgroundColor(e),
      setBlockTextColor: (e) => this.setBlockTextColor(e)
    };
  }
  getDynamicParams() {
    const e = this.hoveredBlockContent.getBoundingClientRect();
    return {
      blockBackgroundColor: this.editor.getAttributes("blockContainer").backgroundColor,
      blockTextColor: this.editor.getAttributes("blockContainer").textColor,
      referenceRect: new DOMRect(
        this.horizontalPosAnchoredAtRoot ? this.horizontalPosAnchor : e.x,
        e.y,
        e.width,
        e.height
      )
    };
  }
}
const rt = (t) => new B({
  key: new v("DraggableBlocksPlugin"),
  view: () => new nt({
    editor: t.editor,
    blockMenuFactory: t.blockSideMenuFactory,
    horizontalPosAnchoredAtRoot: !0
  })
}), it = C.create({
  name: "DraggableBlocksExtension",
  priority: 1e3,
  addProseMirrorPlugins() {
    if (!this.options.blockSideMenuFactory)
      throw new Error(
        "UI Element factory not defined for DraggableBlocksExtension"
      );
    return [
      rt({
        editor: this.editor,
        blockSideMenuFactory: this.options.blockSideMenuFactory
      })
    ];
  }
}), st = new v("HyperlinkToolbarPlugin");
class at {
  constructor({ editor: e, hyperlinkToolbarFactory: o }) {
    h(this, "editor");
    h(this, "hyperlinkToolbar");
    h(this, "menuUpdateTimer");
    h(this, "startMenuUpdateTimer");
    h(this, "stopMenuUpdateTimer");
    h(this, "mouseHoveredHyperlinkMark");
    h(this, "mouseHoveredHyperlinkMarkRange");
    h(this, "keyboardHoveredHyperlinkMark");
    h(this, "keyboardHoveredHyperlinkMarkRange");
    h(this, "hyperlinkMark");
    h(this, "hyperlinkMarkRange");
    this.editor = e, this.hyperlinkToolbar = o(this.getStaticParams()), this.startMenuUpdateTimer = () => {
      this.menuUpdateTimer = setTimeout(() => {
        this.update();
      }, 250);
    }, this.stopMenuUpdateTimer = () => (this.menuUpdateTimer && (clearTimeout(this.menuUpdateTimer), this.menuUpdateTimer = void 0), !1), e.view.dom.addEventListener("mouseover", (n) => {
      if (this.mouseHoveredHyperlinkMark = void 0, this.mouseHoveredHyperlinkMarkRange = void 0, this.stopMenuUpdateTimer(), n.target instanceof HTMLAnchorElement && n.target.nodeName === "A") {
        const r = n.target, a = e.view.posAtDOM(r, 0) + 1, d = e.state.doc.resolve(
          a
        ), s = d.marks();
        for (const i of s)
          if (i.type.name === e.schema.mark("link").type.name) {
            this.mouseHoveredHyperlinkMark = i, this.mouseHoveredHyperlinkMarkRange = V(
              d,
              i.type,
              i.attrs
            ) || void 0;
            break;
          }
      }
      return this.startMenuUpdateTimer(), !1;
    });
  }
  update() {
    var o, n, r, a;
    if (!this.editor.view.hasFocus())
      return;
    const e = this.hyperlinkMark;
    if (this.hyperlinkMark = void 0, this.hyperlinkMarkRange = void 0, this.keyboardHoveredHyperlinkMark = void 0, this.keyboardHoveredHyperlinkMarkRange = void 0, this.editor.state.selection.empty) {
      const d = this.editor.state.selection.$from.marks();
      for (const s of d)
        if (s.type.name === this.editor.schema.mark("link").type.name) {
          this.keyboardHoveredHyperlinkMark = s, this.keyboardHoveredHyperlinkMarkRange = V(
            this.editor.state.selection.$from,
            s.type,
            s.attrs
          ) || void 0;
          break;
        }
    }
    if (this.mouseHoveredHyperlinkMark && (this.hyperlinkMark = this.mouseHoveredHyperlinkMark, this.hyperlinkMarkRange = this.mouseHoveredHyperlinkMarkRange), this.keyboardHoveredHyperlinkMark && (this.hyperlinkMark = this.keyboardHoveredHyperlinkMark, this.hyperlinkMarkRange = this.keyboardHoveredHyperlinkMarkRange), this.hyperlinkMark) {
      if (this.getDynamicParams(), !e) {
        this.hyperlinkToolbar.render(this.getDynamicParams(), !0), (o = this.hyperlinkToolbar.element) == null || o.addEventListener(
          "mouseleave",
          this.startMenuUpdateTimer
        ), (n = this.hyperlinkToolbar.element) == null || n.addEventListener(
          "mouseenter",
          this.stopMenuUpdateTimer
        );
        return;
      }
      this.hyperlinkToolbar.render(this.getDynamicParams(), !1);
      return;
    }
    if (!this.hyperlinkMark && e) {
      (r = this.hyperlinkToolbar.element) == null || r.removeEventListener(
        "mouseleave",
        this.startMenuUpdateTimer
      ), (a = this.hyperlinkToolbar.element) == null || a.removeEventListener(
        "mouseenter",
        this.stopMenuUpdateTimer
      ), this.hyperlinkToolbar.hide();
      return;
    }
  }
  getStaticParams() {
    return {
      editHyperlink: (e, o) => {
        const n = this.editor.view.state.tr.insertText(
          o,
          this.hyperlinkMarkRange.from,
          this.hyperlinkMarkRange.to
        );
        n.addMark(
          this.hyperlinkMarkRange.from,
          this.hyperlinkMarkRange.from + o.length,
          this.editor.schema.mark("link", { href: e })
        ), this.editor.view.dispatch(n), this.editor.view.focus(), this.hyperlinkToolbar.hide();
      },
      deleteHyperlink: () => {
        this.editor.view.dispatch(
          this.editor.view.state.tr.removeMark(
            this.hyperlinkMarkRange.from,
            this.hyperlinkMarkRange.to,
            this.hyperlinkMark.type
          ).setMeta("preventAutolink", !0)
        ), this.editor.view.focus(), this.hyperlinkToolbar.hide();
      }
    };
  }
  getDynamicParams() {
    return {
      url: this.hyperlinkMark.attrs.href,
      text: this.editor.view.state.doc.textBetween(
        this.hyperlinkMarkRange.from,
        this.hyperlinkMarkRange.to
      ),
      referenceRect: j(
        this.editor.view,
        this.hyperlinkMarkRange.from,
        this.hyperlinkMarkRange.to
      )
    };
  }
}
const dt = (t, e) => new B({
  key: st,
  view: () => new at({
    editor: t,
    hyperlinkToolbarFactory: e.hyperlinkToolbarFactory
  })
}), lt = J.extend({
  priority: 500,
  addProseMirrorPlugins() {
    var t;
    if (!this.options.hyperlinkToolbarFactory)
      throw new Error("UI Element factory not defined for HyperlinkMark");
    return [
      ...((t = this.parent) == null ? void 0 : t.call(this)) || [],
      dt(this.editor, {
        hyperlinkToolbarFactory: this.options.hyperlinkToolbarFactory
      })
    ];
  }
}), ct = new v("blocknote-placeholder"), ut = C.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      isFilterClass: "is-filter",
      hasAnchorClass: "has-anchor",
      placeholder: "Write something \u2026",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new B({
        key: ct,
        props: {
          decorations: (t) => {
            const { doc: e, selection: o } = t, n = $.getState(t), r = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: a } = o, d = [];
            if (!!r)
              return e.descendants((s, i) => {
                const l = a >= i && a <= i + s.nodeSize, u = !s.isLeaf && !s.childCount;
                if ((l || !this.options.showOnlyCurrent) && u) {
                  const c = [this.options.emptyNodeClass];
                  this.editor.isEmpty && c.push(this.options.emptyEditorClass), l && c.push(this.options.hasAnchorClass), (n == null ? void 0 : n.triggerCharacter) === "" && (n == null ? void 0 : n.active) && c.push(this.options.isFilterClass);
                  const p = N.node(i, i + s.nodeSize, {
                    class: c.join(" ")
                  });
                  d.push(p);
                }
                return this.options.includeChildren;
              }), L.create(e, d);
          }
        }
      })
    ];
  }
}), ht = C.create({
  name: "trailingNode",
  addProseMirrorPlugins() {
    const t = new v(this.name);
    return [
      new B({
        key: t,
        appendTransaction: (e, o, n) => {
          const { doc: r, tr: a, schema: d } = n, s = t.getState(n), i = r.content.size - 2, l = d.nodes.blockContainer, u = d.nodes.paragraph;
          if (!!s)
            return a.insert(
              i,
              l.create(void 0, u.create())
            );
        },
        state: {
          init: (e, o) => {
          },
          apply: (e, o) => {
            if (!e.docChanged)
              return o;
            let n = e.doc.lastChild;
            if (!n || n.type.name !== "blockGroup")
              throw new Error("Expected blockGroup");
            if (n = n.lastChild, !n || n.type.name !== "blockContainer")
              throw new Error("Expected blockContainer");
            return n.nodeSize > 4;
          }
        }
      })
    ];
  }
});
function pt(t, e = JSON.stringify) {
  const o = {};
  return t.filter((n) => {
    const r = e(n);
    return Object.prototype.hasOwnProperty.call(o, r) ? !1 : o[r] = !0;
  });
}
function mt(t) {
  const e = t.filter(
    (n, r) => t.indexOf(n) !== r
  );
  return pt(e);
}
const ft = C.create({
  name: "uniqueID",
  priority: 1e4,
  addOptions() {
    return {
      attributeName: "id",
      types: [],
      generateID: () => window.__TEST_OPTIONS ? (window.__TEST_OPTIONS.mockID === void 0 ? window.__TEST_OPTIONS.mockID = 0 : window.__TEST_OPTIONS.mockID++, parseInt(window.__TEST_OPTIONS.mockID)) : Ce(),
      filterTransaction: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          [this.options.attributeName]: {
            default: null,
            parseHTML: (t) => t.getAttribute(`data-${this.options.attributeName}`),
            renderHTML: (t) => ({
              [`data-${this.options.attributeName}`]: t[this.options.attributeName]
            })
          }
        }
      }
    ];
  },
  onCreate() {
    if (this.editor.extensionManager.extensions.find(
      (i) => i.name === "collaboration"
    ))
      return;
    const { view: t, state: e } = this.editor, { tr: o, doc: n } = e, { types: r, attributeName: a, generateID: d } = this.options;
    D(n, (i) => r.includes(i.type.name) && i.attrs[a] === null).forEach(({ node: i, pos: l }) => {
      o.setNodeMarkup(l, void 0, {
        ...i.attrs,
        [a]: d()
      });
    }), o.setMeta("addToHistory", !1), t.dispatch(o);
  },
  addProseMirrorPlugins() {
    let t = null, e = !1;
    return [
      new B({
        key: new v("uniqueID"),
        appendTransaction: (o, n, r) => {
          console.log("appendTransaction");
          const a = o.some((k) => k.docChanged) && !n.doc.eq(r.doc), d = this.options.filterTransaction && o.some((k) => {
            var b, g;
            return !(!((g = (b = this.options).filterTransaction) === null || g === void 0) && g.call(b, k));
          });
          if (!a || d)
            return;
          const { tr: s } = r, { types: i, attributeName: l, generateID: u } = this.options, c = ie(
            n.doc,
            o
          ), { mapping: p } = c;
          if (se(c).forEach(({ newRange: k }) => {
            const b = ae(
              r.doc,
              k,
              (M) => i.includes(M.type.name)
            ), g = b.map(({ node: M }) => M.attrs[l]).filter((M) => M !== null), O = mt(g);
            b.forEach(({ node: M, pos: S }) => {
              var R;
              const G = (R = s.doc.nodeAt(S)) === null || R === void 0 ? void 0 : R.attrs[l];
              if (G === null) {
                s.setNodeMarkup(S, void 0, {
                  ...M.attrs,
                  [l]: u()
                });
                return;
              }
              const { deleted: Z } = p.invert().mapResult(S);
              Z && O.includes(G) && s.setNodeMarkup(S, void 0, {
                ...M.attrs,
                [l]: u()
              });
            });
          }), !!s.steps.length)
            return s;
        },
        view(o) {
          const n = (r) => {
            var a;
            t = !((a = o.dom.parentElement) === null || a === void 0) && a.contains(r.target) ? o.dom.parentElement : null;
          };
          return window.addEventListener("dragstart", n), {
            destroy() {
              window.removeEventListener("dragstart", n);
            }
          };
        },
        props: {
          handleDOMEvents: {
            drop: (o, n) => {
              var r;
              return (t !== o.dom.parentElement || ((r = n.dataTransfer) === null || r === void 0 ? void 0 : r.effectAllowed) === "copy") && (t = null, e = !0), !1;
            },
            paste: () => (e = !0, !1)
          },
          transformPasted: (o) => {
            if (!e)
              return o;
            const { types: n, attributeName: r } = this.options, a = (d) => {
              const s = [];
              return d.forEach((i) => {
                if (i.isText) {
                  s.push(i);
                  return;
                }
                if (!n.includes(i.type.name)) {
                  s.push(i.copy(a(i.content)));
                  return;
                }
                const l = i.type.create(
                  {
                    ...i.attrs,
                    [r]: null
                  },
                  a(i.content),
                  i.marks
                );
                s.push(l);
              }), H.from(s);
            };
            return e = !1, new E(
              a(o.content),
              o.openStart,
              o.openEnd
            );
          }
        }
      })
    ];
  }
}), kt = K.create({
  name: "backgroundColor",
  addAttributes() {
    return {
      color: {
        default: void 0,
        parseHTML: (t) => t.getAttribute("data-background-color"),
        renderHTML: (t) => ({
          "data-background-color": t.color
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (t) => typeof t == "string" ? !1 : t.hasAttribute("data-background-color") ? { color: t.getAttribute("data-background-color") } : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["span", t, 0];
  },
  addCommands() {
    return {
      setBackgroundColor: (t) => ({ commands: e }) => t !== "default" ? e.setMark(this.name, { color: t }) : e.unsetMark(this.name)
    };
  }
}), gt = K.create({
  name: "textColor",
  addAttributes() {
    return {
      color: {
        default: void 0,
        parseHTML: (t) => t.getAttribute("data-text-color"),
        renderHTML: (t) => ({
          "data-text-color": t.color
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (t) => typeof t == "string" ? !1 : t.hasAttribute("data-text-color") ? { color: t.getAttribute("data-text-color") } : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["span", t, 0];
  },
  addCommands() {
    return {
      setTextColor: (t) => ({ commands: e }) => t !== "default" ? e.setMark(this.name, { color: t }) : e.unsetMark(this.name)
    };
  }
}), bt = C.create({
  name: "blockBackgroundColor",
  addGlobalAttributes() {
    return [
      {
        types: ["blockContainer"],
        attributes: {
          backgroundColor: {
            default: "default",
            parseHTML: (t) => t.hasAttribute("data-background-color") ? t.getAttribute("data-background-color") : "default",
            renderHTML: (t) => t.backgroundColor !== "default" && {
              "data-background-color": t.backgroundColor
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBlockBackgroundColor: (t, e) => ({ state: o, view: n }) => {
        const r = f(o.doc, t);
        return r === void 0 ? !1 : (o.tr.setNodeAttribute(
          r.startPos - 1,
          "backgroundColor",
          e
        ), n.focus(), !0);
      }
    };
  }
}), yt = C.create({
  name: "blockTextColor",
  addGlobalAttributes() {
    return [
      {
        types: ["blockContainer"],
        attributes: {
          textColor: {
            default: "default",
            parseHTML: (t) => t.hasAttribute("data-text-color") ? t.getAttribute("data-text-color") : "default",
            renderHTML: (t) => t.textColor !== "default" && {
              "data-text-color": t.textColor
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBlockTextColor: (t, e) => ({ state: o, view: n }) => {
        const r = f(o.doc, t);
        return r === void 0 ? !1 : (o.tr.setNodeAttribute(r.startPos - 1, "textColor", e), n.focus(), !0);
      }
    };
  }
}), vt = C.create({
  name: "textAlignment",
  addGlobalAttributes() {
    return [
      {
        types: ["paragraph", "heading", "bulletListItem", "numberedListItem"],
        attributes: {
          textAlignment: {
            default: "left",
            parseHTML: (t) => t.getAttribute("data-text-alignment"),
            renderHTML: (t) => t.textAlignment !== "left" && {
              "data-text-alignment": t.textAlignment
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlignment: (t) => ({ state: e }) => {
        const o = [], n = f(
          e.doc,
          e.selection.from
        );
        if (n === void 0)
          return !1;
        let r = n.startPos;
        for (; r < e.selection.to; )
          e.doc.resolve(r).node().type.spec.group === "blockContent" ? (o.push(r - 1), r += e.doc.resolve(r).node().nodeSize - 1) : r += 1;
        for (const a of o)
          e.tr.setNodeAttribute(a, "textAlignment", t);
        return !0;
      }
    };
  }
}), Ct = (t) => {
  const e = [
    A.ClipboardTextSerializer,
    A.Commands,
    A.Editable,
    A.FocusEvents,
    A.Tabindex,
    he,
    ut.configure({
      emptyNodeClass: y.isEmpty,
      hasAnchorClass: y.hasAnchor,
      isFilterClass: y.isFilter,
      includeChildren: !0,
      showOnlyCurrent: !1
    }),
    ft.configure({
      types: ["blockContainer"]
    }),
    pe,
    ge,
    le,
    ce,
    fe,
    ke,
    be,
    gt,
    yt,
    kt,
    bt,
    vt,
    ...Ue,
    ue.configure({ width: 5, color: "#ddeeff" }),
    me,
    ht
  ];
  return t.blockSideMenuFactory && e.push(
    it.configure({
      blockSideMenuFactory: t.blockSideMenuFactory
    })
  ), t.formattingToolbarFactory && e.push(
    $e.configure({
      formattingToolbarFactory: t.formattingToolbarFactory
    })
  ), t.hyperlinkToolbarFactory ? e.push(
    lt.configure({
      hyperlinkToolbarFactory: t.hyperlinkToolbarFactory
    })
  ) : e.push(J), t.slashMenuFactory && e.push(
    Qe.configure({
      slashMenuFactory: t.slashMenuFactory
    })
  ), e;
}, Bt = {
  enableInputRules: !0,
  enablePasteRules: !0,
  enableCoreExtensions: !1
};
class zt {
  constructor(e = {}) {
    h(this, "tiptapEditor");
    var a, d, s;
    const o = Ct(
      e.uiFactories || {}
    );
    let n = e.disableHistoryExtension ? o.filter((i) => i.name !== "history") : o;
    const r = {
      ...Bt,
      ...e,
      extensions: e.enableBlockNoteExtensions === !1 ? e.extensions : [...e.extensions || [], ...n],
      editorProps: {
        attributes: {
          ...((a = e.editorProps) == null ? void 0 : a.attributes) || {},
          class: [
            U.bnEditor,
            U.bnRoot,
            ((s = (d = e.editorProps) == null ? void 0 : d.attributes) == null ? void 0 : s.class) || ""
          ].join(" ")
        }
      }
    };
    this.tiptapEditor = new de(r);
  }
}
export {
  zt as BlockNoteEditor,
  I as SlashMenuItem,
  Ct as getBlockNoteExtensions
};
//# sourceMappingURL=blocknote.js.map
